import React from "react"
import ReactDOM from "react-dom"
import { Router, Route, IndexRoute, browserHistory } from "react-router"
import ForgotPassword from "./pages/auth/ForgotPassword"
import ResetPassword from "./pages/auth/ResetPassword"
import Dashboard from "./pages/dashboard/Dashboard"
import Users from "./pages/users/Users"
import Account from "./pages/account/Account"
import UserDetails from "./pages/users/user-details/UserDetails"
import Hierarchy from "./pages/hierarchy/Hierarchy"
import TopRecords from "./pages/records/TopRecords"
import Timecards from "./pages/timecards/Timecards"
import Equipment from "./pages/equipment/Equipment"
import EquipmentDetails from "./pages/equipment/equipment-details/EquipmentDetails"
import injectTapEventPlugin from "react-tap-event-plugin"
import OemAdmin from "./pages/OemAdmin"
import Section1 from "./pages/onboarding/I9-edit/section1/Section1"
import Login from "./pages/auth/Login"
import Login2 from "./pages/auth/Login2"
import SSO from "./pages/SSO"
import EmployeeSelfDetails from "./pages/users/user-details/EmployeeSelfDetails"
import Layout from "./pages/Layout"
import NoMatch from "./pages/NoMatch"
import TopLevelDevices from "./pages/toplevel-devices/Devices"
import Payroll from "./pages/payroll/Payroll"
import LeaveTracking from "./pages/leave-tracking/LeaveTracking"
import Schedule from "./pages/schedules/Schedule"
import NotificationSettings from "./pages/notification-setting/NotificationSettings"
import Clients from "./pages/clients/Clients"
import Jobs from "./pages/jobs/Jobs"
import JobDetails from "./pages/jobs/job-details/JobDetails"
import ClientDetails from "./pages/clients/client-details/ClientDetails"
import AccountManager from "./pages/account_manager/AccountManager"
import VerifyEmail from "./pages/registration/VerifyEmail"
import AccountRegistration from "./pages/registration/AccountRegistration"
import AccountRegistrationInfo from "./pages/registration/AccountRegistrationInfo"
import AccountRegistrationCompleted from "./pages/registration/AccountRegistrationCompleted"
import Workflows from "./pages/workflows/Workflows"
import MobileDashboard from "./pages/dashboard/MobileDashboard"
import GigPool from "./pages/gigpool/GigPool"

import "../main.css"

if (process.env.NODE_ENV !== "production") {
    require("./logger")
}

//Needed for onTouchTap
//Can go away when react 1.0 release
//Check this repo:
//https://github.com/zilverline/react-tap-event-plugin
injectTapEventPlugin()

ReactDOM.render(
    <Router history={browserHistory}>
        <Route path="login" name="login" component={Login2} />
        <Route path="verify_email" name="verifyemail" component={VerifyEmail} />
        <Route path="account_registration" name="accountregistration" component={AccountRegistration} />
        <Route path="account_registration_info" name="accountregistration" component={AccountRegistrationInfo} />
        <Route path="account_registration_completed" name="accountregistration" component={AccountRegistrationCompleted} />
        <Route path="mobile-dashboard" name="mobile-dashboard" component={MobileDashboard} />
        <Route path="forgot_password" name="forgotpassword" component={ForgotPassword} />
        <Route path="reset_password/:token" name="resetpassword" component={ResetPassword} />
        <Route exact path="/" component={Layout}>
            <IndexRoute name="login" component={Login2} />
            <Route path="es/:subpage" name="EmployeeDetails" component={EmployeeSelfDetails} />
            <Route path="sso-login/:token" name="sso-login" component={SSO} />
            <Route path="dashboard" name="dashboard" component={Dashboard} />
            <Route path="employees" name="employees" component={Users} />
            <Route path="account/:accountId/:subpage" name="account" component={Account} />
            <Route path="user-details/:userId/:subpage" name="userDetails" component={UserDetails} />
            <Route path="hierarchy/:subpage" name="hierarchy" component={Hierarchy} />
            <Route path="records" name="records" component={TopRecords} />
            <Route path="timecards" name="timecards" component={Timecards} />
            <Route path="timecards/:filter" name="records" component={Timecards} />
            <Route path="equipment" name="equipment" component={Equipment} />
            <Route path="equipment-details/:equipmentId/:subpage" name="equipmentDetails" component={EquipmentDetails} />
            <Route path="oem-admin" name="oemAdmin" component={OemAdmin} />
            <Route path="i9/:shortCode" name="i9" component={Section1} />
            <Route path="toplevel-devices" name="toplevel-devices" component={TopLevelDevices} />
            <Route path="payroll" name="payroll" component={Payroll} />
            <Route path="leave-tracking" name="leave-tracking" component={LeaveTracking} />
            <Route path="schedule/:filter" name="schedule" component={Schedule} />
            <Route path="notification_settings" name="notificationSettings" component={NotificationSettings} />
            <Route path="clients" name="clients" component={Clients} />
            <Route path="client-details/:clientId" name="clientDetails" component={ClientDetails} />
            <Route path="jobs" name="jobs" component={Jobs} />
            <Route path="job-details/:jobId" name="jobDetails" component={JobDetails} />
            <Route path="accountmanager" name="accountmanager" component={AccountManager} />
            <Route path="workflows" name="workflows" component={Workflows} />
            <Route path="gigpool" name="gigpool" component={GigPool} />
        </Route>
        <Route path="*" component={NoMatch} />
    </Router>,
    app
)